.container {
  display: inline-block;
}

.toggleButton {
  margin-right: 0.5rem;
}

.overlayPanel {
  min-width: 400px;
}

.overlayContent {
  padding: 1rem;
}

.title {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: 600;
}

.description {
  margin-bottom: 1.5rem;
  font-size: 0.775rem;
  line-height: 1.5;
  color: var(--text-color-secondary);
  width: 400px;
}

.inputGroup {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.label {
  min-width: 140px;
  margin-right: 0.5rem;
  font-weight: 500;
}

.input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid var(--surface-border);
  border-radius: 4px;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 0.2rem var(--primary-color-text);
  }
}
